import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Divider,
	SvgIcon,
	Typography,
} from '@mui/material';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { borderRadius, palette, spaces } from '../../assets/styles/themes/tokens';
import getMuiIcon from '../../utils/getMuiIcon';

const titleStyles = {
	marginBottom: spaces.xxl,
	textAlign: 'center',
	color: palette.text.primary,
};

const accordionsWrapperStyles = {
	backgroundColor: palette.background.paperElevation2,
	borderRadius: borderRadius.xs,
	overflow: 'hidden',
};

const accordionStyles = {
	'&:before': {
		display: 'none', // Removes the default divider
	},
};

const accordionSummaryStyles = {
	paddingX: spaces.md,
	'&.Mui-expanded': {
		paddingBottom: 0,
	},
};

const expandIconStyles = {
	color: palette.accordion.expandIcon.color,
	transform: 'rotate(0deg)',
	transition: 'transform 0.2s',
	'&.Mui-expanded': {
		transform: 'rotate(-180deg)',
	},
};

const accordionDetailsStyles = {
	color: palette.text.secondary,
	paddingTop: 0,
	paddingBottom: spaces.lg,
};

const accordionSummaryTitleStyles = {
	color: palette.text.primary,
	paddingY: spaces.xs,
};

const accordionDetailsAnswerStyles = {
	color: palette.text.primary,
};

const dividerStyles = {
	marginX: spaces.md,
	backgroundColor: palette.divider,
};

const FAQ: React.FC = () => {
	const { t } = useTranslation();

	const faqItems = [
		{
			question: t('Can I switch between the plans?'),
			answer: t(
				'Yes, this is possible at any time. You can easily switch from meineFortbildung or meinUnterricht Pro to meinUnterricht 360. Your contract duration will remain unchanged.'
			),
		},
		{
			question: t('What payment methods can I use?'),
			answer: t('You can conveniently pay with SEPA direct debit, PayPal, or credit card.'),
		},
		{
			question: t('What happens if I reach my usage limit?'),
			answer: t(
				'Once you reach your monthly download or course limit, you will not be able to make any additional downloads or enroll in courses for the current calendar month. At the start of the next month, your full quota will be available again.'
			),
		},
		{
			question: t('Are there discounts for trainee teachers?'),
			answer: t(
				'Yes, as a trainee teacher, you receive a 50% discount on the meinUnterricht Pro and meinUnterricht 360 plans.'
			),
		},
	];

	return (
		<>
			<Typography variant="h5" sx={titleStyles}>
				{t('Frequently Asked Questions')}
			</Typography>

			<Box sx={accordionsWrapperStyles}>
				{faqItems.map((item, index) => (
					<Fragment key={item.question}>
						<Accordion square key={item.question} sx={accordionStyles} disableGutters elevation={0}>
							<AccordionSummary
								expandIcon={<SvgIcon component={getMuiIcon('arrowDown')} sx={expandIconStyles} />}
								sx={accordionSummaryStyles}
							>
								<Typography variant="h6" sx={accordionSummaryTitleStyles}>
									{item.question}
								</Typography>
							</AccordionSummary>
							<AccordionDetails sx={accordionDetailsStyles}>
								<Typography variant="body1" sx={accordionDetailsAnswerStyles}>
									{item.answer}
								</Typography>
							</AccordionDetails>
						</Accordion>
						{index < faqItems.length - 1 && <Divider sx={dividerStyles} />}
					</Fragment>
				))}
			</Box>
		</>
	);
};

export default FAQ;
